import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../actions/actions';

class Save extends React.Component {
    constructor(props) {
        super(props);
        this.inputValue = null;
        this.saveForm = this.saveForm.bind(this);
    }

    saveForm(e) {
        e.preventDefault();
        if (this.props.app.name !== '') {
            this.props.actions.setAppName(this.inputValue);
            this.props.actions.save();
            this.props.buttonSecondary();
        }
    }

    render() {
        const { buttonSecondary } = this.props;

        return (
            <div>
                <header className="modal-header">
                    <h3>Save</h3>
                </header>
                <form onSubmit={this.saveForm}>
                    <div className="modal-body">
                        <div className="input">
                            <div className="input__field">
                                <input type="text" id="name" placeholder="Save as ..." onChange={(e) => { this.inputValue = e.target.value; }} required />
                            </div>
                        </div>
                    </div>
                    <div className="modal-buttons">
                        <a className="modal-buttons__button cancel-button" onClick={buttonSecondary}>Close</a>
                        <button type="submit" className="modal-buttons__button confirm-button">Save</button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    modal: state.modal,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Save.propTypes = {
    app: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
    buttonSecondary: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Save);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Save.jsx